import type { Unit } from "../api/types";
import { cmToFtIn, parseHeight } from "../lib/units";

/** Height input with an ft/in or cm toggle. Switching units converts what's typed. */
export function HeightFields(props: { unit: Unit; a: string; b: string; onUnit: (u: Unit) => void; onA: (v: string) => void; onB: (v: string) => void }) {
  const { unit, a, b, onUnit, onA, onB } = props;
  const switchTo = (u: Unit) => {
    if (u === unit) return;
    const cm = parseHeight(unit, a, b);
    onUnit(u);
    if (cm == null) {
      onA("");
      onB("");
    } else if (u === "cm") {
      onA(String(Math.round(cm)));
      onB("");
    } else {
      const { ft, inch } = cmToFtIn(cm);
      onA(String(ft));
      onB(String(inch));
    }
  };
  return (
    <div className="stack">
      <div className="row" role="group" aria-label="Units">
        <button type="button" className="chip sm" aria-pressed={unit === "in"} onClick={() => switchTo("in")}>
          ft / in
        </button>
        <button type="button" className="chip sm" aria-pressed={unit === "cm"} onClick={() => switchTo("cm")}>
          cm
        </button>
      </div>
      {unit === "cm" ? (
        <div className="hfields">
          <label className="seam">
            <input inputMode="decimal" aria-label="Height in centimeters" placeholder="168" value={a} onChange={(e) => onA(e.target.value)} />
            <span className="unit">cm</span>
          </label>
        </div>
      ) : (
        <div className="hfields">
          <label className="seam">
            <input inputMode="numeric" aria-label="Feet" placeholder="5" value={a} onChange={(e) => onA(e.target.value)} />
            <span className="unit">ft</span>
          </label>
          <label className="seam">
            <input inputMode="numeric" aria-label="Inches" placeholder="6" value={b} onChange={(e) => onB(e.target.value)} />
            <span className="unit">in</span>
          </label>
        </div>
      )}
    </div>
  );
}
